/**
 * The two user-facing module layers (segmented toggle). An `as const` object so
 * call sites reference `ModuleLayer.Advisor` / `ModuleLayer.Client` instead of
 * bare string literals — same pattern as the API-derived enums.
 *
 * The on-screen toggle that switches between them now lives in the page header
 * (`HeaderLayerToggle`), reading the app-root `ModuleLayerProvider`. This file
 * keeps only the enum, which both the provider and the header toggle import.
 */
export const ModuleLayer = {
	Advisor: "advisor",
	Client: "client",
} as const;
export type ModuleLayer = (typeof ModuleLayer)[keyof typeof ModuleLayer];
